import { useHistory, useLocation } from "react-router-dom"
import { useSelector } from "react-redux";
import { currentSharedMailBoxIdSelector } from "../selectors";



export const useNavigation = () => {
    const history = useHistory();
    const location = useLocation();
    const smId = useSelector(currentSharedMailBoxIdSelector);
    const userSession = useSelector(store => store.appModes.userSession || store.userDetails.userId);


    const getSearchQuery = (savePreviousQuery=false) => {
        const searchParams = new URLSearchParams(savePreviousQuery ? window.location.search: '');
        searchParams.set('usersession', userSession);
        return searchParams.toString();
    }

    const navigateTo = (url, exact=false, savePreviousQuery=false) => {
        const searchQuery = getSearchQuery(savePreviousQuery);
        const newUrl = exact ? url : `${location.pathname}${url}`;
        const urlQueryPart = newUrl.split('?')[1];
        // If newUrl already contains query parameters, the search query is appended with an `&`, otherwise, it is appended with a `?`.
        const urlPath = urlQueryPart ? `${newUrl}&${searchQuery}` : `${newUrl}?${searchQuery}`;
        history.push(urlPath);
    }

    const navigateInSM = (url, savePreviousQuery=false) => {
        const searchQuery = getSearchQuery(savePreviousQuery);
        const newUrl = `/app/sharedmailbox/edit/${smId}${url}`;
        const urlQueryPart = newUrl.split('?')[1];
        // If newUrl already contains query parameters, the search query is appended with an `&`, otherwise, it is appended with a `?`.
        const urlPath = urlQueryPart ? `${newUrl}&${searchQuery}` : `${newUrl}?${searchQuery}`;
        history.push(urlPath);
    }

    const getSearchParams = () => {
        const url = new URL(window.location);
        const searchParams = url.searchParams;
        const params = {};
        for (const key of searchParams.keys()) {
            params[key] = searchParams.get(key)
        }
        return params;
    }

    const deleteSearchParams = (searchParams = []) => {
        const currentUrl = new URL(window.location.href);
        if (!Array.isArray(searchParams)) return;
        for (const queryKey of searchParams) {
            currentUrl.searchParams.delete(queryKey);
        }
        const newUrl = currentUrl.toString();
        window.history.pushState({}, '', newUrl);
    }

    return{
        navigateTo,
        location,
        searchParams: getSearchParams(),
        deleteSearchParams,
        navigateInSM
    }
}